export default function Logo() {
  return (
    <div className="flex items-center">
      <div className="md:h-[4rem] md:w-[50px] h-[4rem] w-[4rem] relative">
        <img src="/images/logo.png" className="absolute inset-0" alt="" />
      </div>
      <span className="md:block hidden">Konson Ak</span>
    </div>
  );
}
